// 编辑器占位卡按 uuid 运行时解析本人文件名/包名(节点仍只存 uuid,名字绝不落进
// content JSON)。view-first:走 v_file_info_mine / v_resource_pack_mine(owner 收口),
// 不能用 get_public_files(编辑器里可能是未公开的自有文件)。查不到(已删/回收站)
// 返回 null,由占位卡回退「嵌入文件/嵌入资源包」文案。

import { useQuery } from '@tanstack/react-query'
import { getSupabase } from '@dogdisk/shared'

async function fetchNameById(view: string, id: string): Promise<string | null> {
  const sb = getSupabase()
  const { data, error } = await sb.from(view).select('name').eq('id', id).maybeSingle()
  if (error) throw new Error(error.message)
  return (data as { name: string } | null)?.name ?? null
}

/** fileRef 占位卡:按 fileId 解析本人文件名(v_file_info_mine)。 */
export function useMyFileName(fileId: string | null) {
  return useQuery({
    queryKey: ['file', 'embed-name', fileId] as const,
    enabled: !!fileId,
    queryFn: () => fetchNameById('v_file_info_mine', fileId!),
  })
}

/** packRef 占位卡:按 packId 解析本人资源包名(v_resource_pack_mine)。 */
export function useMyPackName(packId: string | null) {
  return useQuery({
    queryKey: ['pack', 'embed-name', packId] as const,
    enabled: !!packId,
    queryFn: () => fetchNameById('v_resource_pack_mine', packId!),
  })
}
